import { Flex, Typography } from '@iheartjane/reefer';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';

import { ImageCommsBanner } from '@jane/shared-ecomm/components';

import type { RootLoaderType } from '../../../data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '../../../hooks';
import { useMenu } from '../../../providers';
import type { MenuCategory } from '../../../types';
import { Banner } from './Banner';

export const FeaturedBanner = () => {
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { bannerMessage } = useMenu();
  const { category = 'all' } = useParams<{ category: MenuCategory }>();
  const { getKioskSpacing, defaultSpacing } = useKioskSpacing();

  const navigate = useNavigate();

  const onShowMessage = useCallback(() => {
    navigate(`/stores/${storeId}/menu/${category}/comms-banner`);
  }, [navigate, storeId, category]);

  const showBanner = useMemo(
    () =>
      bannerMessage?.enabled &&
      (bannerMessage?.banner_type === 'image' ||
        bannerMessage.title ||
        bannerMessage.message),
    [
      bannerMessage?.enabled,
      bannerMessage?.message,
      bannerMessage?.title,
      bannerMessage?.banner_type,
    ]
  );

  if (showBanner && bannerMessage?.banner_type === 'text') {
    return (
      <Banner expandText="Show message" onExpand={onShowMessage}>
        <Typography maxLines={1}>{bannerMessage?.title}</Typography>
      </Banner>
    );
  } else if (showBanner && bannerMessage?.banner_type === 'image') {
    return (
      <Flex width="100%" mt={defaultSpacing} px={getKioskSpacing(64, 48)}>
        <ImageCommsBanner
          buttonFillColor={`#${bannerMessage?.button_fill_color}`}
          buttonLink={bannerMessage?.button_link}
          buttonText={bannerMessage?.button_text}
          buttonTextColor={`#${bannerMessage?.button_text_color}`}
          fallbackSrc={bannerMessage?.fallbackSrc}
          headerTextColor={`#${bannerMessage?.header_text_color}`}
          imageAltText={bannerMessage?.alt_text}
          imageOpacity={bannerMessage?.image_opacity}
          imageUrl={bannerMessage?.image?.file?.url}
          message={bannerMessage?.message}
          sizes={bannerMessage?.sizes}
          srcSet={bannerMessage?.srcSet}
          target={'_self'}
          title={bannerMessage?.title}
        />
      </Flex>
    );
  } else {
    return null;
  }
};
